module.exports = __webpack_public_path__ + "static/spell-sell-banner-948ea57e7acaff9e634235338c9d8c28.png";